<template>
  <div class="row" v-if="variables && variables.length > 0">
    <div class="col-md-12">
      <p class="text-muted mb-0">
        {{$t("You can use following variables::")}}
      </p>
      <p class="text-muted mb-0" v-for="variable in variables"
         :key="`template-var-${variable.name}`">
        <small>
          {{`\{\{${variable.name}\}\}`}} - {{variable.description}}
        </small>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TemplateVariables",
    props: {
      variables: {
        type: Array,
        default: () => []
      }
    }
  }
</script>

<style scoped>
</style>
